import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	routes: [
		{ // 无访问权限路由
			path: '/',
			name: 'index',
			component: () => import('@/components/HelloWorld.vue'),
			
		},
    { // 无访问权限路由
			path: '/a',
			name: 'name',
			component: () => import('@/components/Company.vue'),
			
		}
	]
})
export default router;